import React from 'react';

export function AHUImage() {
  return (
    <div className="flex-1 flex flex-col items-center justify-center">
      <div className="relative w-full max-w-[320px] aspect-square">
        <img 
          src="https://raw.githubusercontent.com/Pamekitti/assets/main/ba938858557cc8f083c45937bd253ff6.png"
          alt="AHU Unit"
          className="w-full h-full object-contain"
        />
      </div>
    </div>
  );
}